var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5392 10C20.5051 10.0018 20.4711 10.0017 20.4373 10H15C14.4477 10 14 9.55228 14 9C14 8.44772 14.4477 8 15 8H18.9309C17.5287 5.57209 14.9137 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C15.4168 20 18.4229 17.8381 19.5442 14.6692C19.7284 14.1486 20.2998 13.8758 20.8205 14.0601C21.3411 14.2443 21.6138 14.8157 21.4296 15.3364C20.0279 19.2981 16.2708 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.2232 2 18.1537 3.53894 20 5.9968V3C20 2.44772 20.4477 2 21 2C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10H20.5392Z",
    fill: "currentColor"
  })));
};
export default SvgRefresh;